import { Accordion } from "react-bootstrap";
import Tel1Program from "./objectiveProgramSection";
import { useState } from "react";
import Tel1Tool from "./objectiveToolSection";
import Tel1Fasilitator from "./objectiveFasilitatorSection";
import Tel1Overall from "./objectiveOverallSection";
import Tel1OverallComment from "./subjectiveOverallSection";
import Tel1OtherComment from "./subjectiveOtherSection";

function Tel1EpdTemplate({ epdTemplateData = null }) {
  const [isOpenTel1, setIsOpenTel1] = useState(false);
  return (
    <>
      <div className="mb-3">
        <div className="mb-3">
          <a href="#/" className="toggle" onClick={() => setIsOpenTel1(!isOpenTel1)}>
            {isOpenTel1 ? "Hide ▲" : "More ▼"}
          </a>
        </div>
        <Accordion activeKey={isOpenTel1 ? "0" : null}>
          <Accordion.Item eventKey="0">
            <Accordion.Body>
              <Tel1Program summaryData={epdTemplateData.objectiveEpd.program} />
              <Tel1Tool summaryData={epdTemplateData.objectiveEpd.tool} />
              <Tel1Fasilitator summaryData={epdTemplateData.objectiveEpd.fasilitator} />
              <Tel1Overall overAllData={epdTemplateData.objectiveEpd.overall} />
              <Tel1OverallComment commentData={epdTemplateData.subjective.overallComment} />
              <Tel1OtherComment commentData={epdTemplateData.subjective.otherComment} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
}

export default Tel1EpdTemplate;
